import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import { createPinia } from "pinia";
import { i18n } from "./languages/i18n";

// PrimeVue 4 Essentials
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura'; // Preset standard di sistema
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import ToastService from 'primevue/toastservice';

// Componenti necessari registrati globalmente
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import Tag from 'primevue/tag';
import ProgressBar from 'primevue/progressbar';
import Dialog from 'primevue/dialog';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';

// Stili esterni
import 'primeicons/primeicons.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "../src/assets/styles/style.scss";
import "../src/style.css";
import { applyProviderBodyClass } from "./helpers/provider";

applyProviderBodyClass();

const app = createApp(App);

app.use(PrimeVue, {
    theme: {
        preset: Aura, // Usiamo Aura come base sicura
        options: {
            prefix: 'p',
            darkModeSelector: '.p-dark',
            cssLayer: {
                name: 'primevue',
                order: 'theme, base, primevue',
            },
        },
    },
});

app.use(store);
app.use(createPinia());
app.use(i18n);
app.use(ConfirmationService);
app.use(ToastService);
app.use(DialogService);
app.use(router);

// Registrazione componenti per uso immediato nel template
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('Button', Button);
app.component('Tag', Tag);
app.component('ProgressBar', ProgressBar);
app.component('Dialog', Dialog);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);

router.isReady().then(() => {
    app.mount("#app");
});